import "chart.js/auto";
import { Line } from "react-chartjs-2";
import { COLORS, formatNumber, formatShortDate } from "../utils";

// 호버한 날짜에 세로선 (기존 유입분석 차트와 같은 동작)
const crosshairPlugin = {
    id: 'inflowCrosshair',
    afterDraw: (chart) => {
        const active = chart.tooltip?.getActiveElements?.() || [];
        if (!active.length) {
            return;
        }
        const { ctx, chartArea } = chart;
        const x = active[0].element.x;
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, chartArea.top);
        ctx.lineTo(x, chartArea.bottom);
        ctx.lineWidth = 1;
        ctx.strokeStyle = '#d1d5db';
        ctx.stroke();
        ctx.restore();
    },
};

const SERIES = [
    { key: 'visits', label: '방문', color: COLORS.visits },
    { key: 'clicks', label: '링크 클릭', color: COLORS.clicks },
];

export function FgTrendChart({ daily }) {
    const data = {
        labels: daily.map(d => formatShortDate(d.date)),
        datasets: SERIES.map(s => ({
            label: s.label,
            data: daily.map(d => d[s.key]),
            borderColor: s.color,
            backgroundColor: s.color,
            borderWidth: 2,
            pointRadius: daily.length > 31 ? 0 : 2.5,
            pointHoverRadius: 5,
            pointHoverBorderWidth: 2,
            pointHoverBorderColor: '#fff',
            tension: 0.3,
        })),
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        interaction: { mode: 'index', intersect: false },
        plugins: {
            legend: { display: false },
            tooltip: {
                backgroundColor: '#111827',
                padding: 10,
                boxPadding: 4,
                callbacks: {
                    title: (items) => daily[items[0].dataIndex].date,
                    label: (item) => ` ${item.dataset.label} ${formatNumber(item.parsed.y)}`,
                    afterBody: (items) => {
                        const d = daily[items[0].dataIndex];
                        return d.visits ? `클릭률 ${((d.clicks / d.visits) * 100).toFixed(1)}%` : '';
                    },
                },
            },
        },
        scales: {
            x: { grid: { display: false }, ticks: { color: '#6b7280', maxTicksLimit: 8, maxRotation: 0 } },
            y: { beginAtZero: true, grid: { color: '#f1f1f1', drawBorder: false }, ticks: { color: '#6b7280', precision: 0, maxTicksLimit: 5 } },
        },
    };

    return (
        <div>
            <div className="mb-3 flex items-center gap-4" aria-hidden="true">
                {SERIES.map(s => (
                    <span key={s.key} className="flex items-center gap-1.5 text-xs text-gray-600">
                        <span className="inline-block h-0.5 w-4 rounded-full" style={{ background: s.color }} />
                        {s.label}
                    </span>
                ))}
            </div>
            <div className="h-[260px]">
                <Line data={data} options={options} plugins={[crosshairPlugin]} role="img" aria-label="일별 방문과 링크 클릭 추이" />
            </div>
            <details className="mt-3 text-xs text-gray-500">
                <summary className="cursor-pointer select-none">표로 보기</summary>
                <div className="mt-2 max-h-[240px] overflow-y-auto">
                    <table className="w-full text-left">
                        <thead className="sticky top-0 bg-white text-gray-400">
                            <tr><th className="py-1 font-normal">날짜</th><th className="text-right font-normal">방문</th><th className="text-right font-normal">유효 방문</th><th className="text-right font-normal">링크 클릭</th></tr>
                        </thead>
                        <tbody>
                            {daily.slice().reverse().map(d => (
                                <tr key={d.date} className="border-t border-gray-100 text-gray-700">
                                    <td className="py-1">{d.date}</td>
                                    <td className="text-right">{formatNumber(d.visits)}</td>
                                    <td className="text-right">{formatNumber(d.firstVisits)}</td>
                                    <td className="text-right">{formatNumber(d.clicks)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </details>
        </div>
    );
}
